function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var VirginIslandsUSFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_485",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_485)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#F7FCFF"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_485",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "24",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21H24V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_485)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.8605 7.44524C12.8605 7.58362 13.4923 9.5288 13.4923 9.5288H10.4263L11.2881 7.84712C11.2881 7.84712 11.414 7.52623 11.1058 7.44524C10.7976 7.36426 10.4263 7.7135 10.4263 7.7135C10.4263 7.7135 10.5169 7.15475 10.6379 7.03373C10.759 6.9127 11.4666 6.60242 12.0564 6.60242C12.6462 6.60242 12.8605 7.30686 12.8605 7.44524ZM6.49932 7.79717L6.49932 7.79717L6.49933 7.79717L6.49934 7.79717C7.52907 8.10402 8.36046 8.35177 8.4696 8.35177C8.76854 8.35177 9.99878 9.61668 9.99878 9.61668V12.4455C9.99878 12.4455 6.11588 11.6395 2.45344 7.66725C1.91631 7.13536 1.71244 6.81113 2.08294 6.65215C2.31817 6.55122 4.70864 7.26356 6.49932 7.79717ZM9.63286 12.6239C9.63286 12.6239 9.22561 12.9045 8.77504 13.6559C8.55339 14.0255 8.53555 14.3512 8.52266 14.5866C8.50933 14.8298 8.50128 14.9768 8.27942 14.9768C8.02045 14.9768 7.83255 15.0329 7.67963 15.0785C7.57469 15.1097 7.48623 15.1361 7.40255 15.1361C7.19695 15.1361 6.80217 15.9122 6.99956 16.0919C7.19695 16.2715 8.02399 16.5578 8.02399 16.0919C8.02399 15.626 8.24644 15.3613 8.65064 15.3613C9.05484 15.3613 9.77732 15.0937 9.77732 14.5064C9.77732 13.9192 10.5651 13.9612 10.5651 13.9612L9.63286 12.6239ZM17.671 7.79717C19.4617 7.26356 21.8521 6.55122 22.0874 6.65215C22.4579 6.81113 22.254 7.13536 21.7169 7.66725C20.2788 10.2408 14.1715 12.4455 14.1715 12.4455V9.61668C14.1715 9.61668 15.4018 8.35177 15.7007 8.35177C15.8099 8.35177 16.6413 8.10402 17.671 7.79717L17.671 7.79717ZM14.5375 12.6239C14.5375 12.6239 14.9447 12.9045 15.3953 13.6559C15.6169 14.0255 15.6348 14.3512 15.6477 14.5866C15.661 14.8298 15.669 14.9768 15.8909 14.9768C16.1499 14.9768 16.3378 15.0329 16.4907 15.0785C16.5956 15.1097 16.6841 15.1361 16.7678 15.1361C16.9734 15.1361 17.3681 15.9122 17.1708 16.0919C16.9734 16.2715 16.1463 16.5578 16.1463 16.0919C16.1463 15.626 15.9239 15.3613 15.5197 15.3613C15.1155 15.3613 14.393 15.0937 14.393 14.5064C14.393 13.9192 13.6053 13.9612 13.6053 13.9612L14.5375 12.6239ZM9.38136 15.7522C9.38136 15.4957 10.6129 14.128 10.6129 14.128L11.9889 13.5473C11.9889 13.5473 11.996 13.6783 12.0065 13.8959C12.017 13.6783 12.0241 13.5473 12.0241 13.5473L13.4001 14.128C13.4001 14.128 14.6316 15.4957 14.6316 15.7522C14.6316 16.0087 12.2696 18.0986 12.0241 18.0986C12.0179 18.0986 12.0121 18.0957 12.0065 18.0901C12.0009 18.0957 11.9951 18.0986 11.9889 18.0986C11.7434 18.0986 9.38136 16.0087 9.38136 15.7522Z",
        fill: "#E8AA00"
      }), /*#__PURE__*/_jsx("path", {
        d: "M4.68494 11.2442L6.10816 10.7705C7.07008 13.6603 7.99738 15.5283 8.83079 16.3356L7.78716 17.413C6.7324 16.3914 5.71808 14.348 4.68494 11.2442Z",
        fill: "#46A000"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.5188 10.754H19.9158C19.9158 10.754 20.2556 10.754 20.293 11.0822C20.293 11.0822 20.3008 13.8527 20.293 14.0703C20.2851 14.288 19.9158 14.3621 19.9158 14.3621C19.9158 14.3621 21.8604 14.368 21.5188 14.3621C21.1771 14.3561 21.1017 14.0703 21.1017 14.0703V11.0822C21.1017 10.8293 21.5188 10.754 21.5188 10.754ZM3.42403 14.14C3.24259 13.6715 2.12231 10.8032 2.12231 10.8032H3.23137C3.0387 10.8032 2.96716 11.0484 2.96716 11.0484L3.74399 13.2633C3.74399 13.2633 4.4952 11.455 4.4952 11.1343C4.4952 10.8136 4.17986 10.8032 4.17986 10.8032H5.62575L5.27644 10.9198C5.27644 10.9198 4.1195 13.5722 4.1195 14.14C4.06438 14.2658 4.65216 14.3496 4.65216 14.3496H3.09952L3.42403 14.14ZM16.7 13.0925L17.5592 11.5093L17.5845 13.2708L17.3183 13.1844L17.1296 14.3607L18.0798 12.5385L17.7634 12.4196L18.9397 11.1463L18.5391 12.8672L18.3112 12.6665L16.9637 15.1807L18.4677 13.4574L18.1778 13.3127L19.663 12.3402L19.0164 13.9249L18.6557 13.6652L17.1296 15.5865L16.4966 15.3431L17.1296 13.0925H16.7ZM16.2038 16.095H15.7287V16.4564H15.3547L14.2953 17.6852H14.88L15.0831 18.3771L15.3547 18.133V18.3771L15.8857 18.133L16.3933 18.5725L16.7722 16.8828L16.5172 16.6956L16.6482 16.5811L16.5172 16.095H16.2038Z",
        fill: "#0093E1"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.25768 9.00966C9.25768 9.00966 9.95562 9.49159 10.6536 9.49159C11.3515 9.49159 12.0494 9.00966 12.0494 9.00966C12.0494 9.00966 12.7474 9.49159 13.4453 9.49159C14.1433 9.49159 14.8412 9.00966 14.8412 9.00966V11.1853C14.8412 13.4349 12.0494 15.1783 12.0494 15.1783C12.0494 15.1783 9.1225 13.5775 9.25768 11.1586V9.00966Z",
        fill: "#F7FCFF"
      }), /*#__PURE__*/_jsx("mask", {
        id: "mask2_621_485",
        style: {
          maskType: 'luminance'
        },
        maskUnits: "userSpaceOnUse",
        x: "9",
        y: "9",
        width: "6",
        height: "7",
        children: /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.25768 9.00966C9.25768 9.00966 9.95562 9.49159 10.6536 9.49159C11.3515 9.49159 12.0494 9.00966 12.0494 9.00966C12.0494 9.00966 12.7474 9.49159 13.4453 9.49159C14.1433 9.49159 14.8412 9.00966 14.8412 9.00966V11.1853C14.8412 13.4349 12.0494 15.1783 12.0494 15.1783C12.0494 15.1783 9.1225 13.5775 9.25768 11.1586V9.00966Z",
          fill: "white"
        })
      }), /*#__PURE__*/_jsxs("g", {
        mask: "url(#mask2_621_485)",
        children: [/*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.06006 8.86505H14.9401V11.1301H9.06006V8.86505Z",
          fill: "#2E42A5"
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.1965 11.1302H9.70239V15.7085H10.1965V11.1302ZM11.0365 11.1302H10.5424V15.7085H11.0365V11.1302ZM11.3824 11.1302H11.8765V15.7085H11.3824V11.1302ZM12.7165 11.1302H12.2224V15.7085H12.7165V11.1302ZM13.0624 11.1302H13.5565V15.7085H13.0624V11.1302ZM14.3965 11.1302H13.9024V15.7085H14.3965V11.1302Z",
          fill: "#AF0100"
        })]
      })]
    })]
  })]
}));
//# sourceMappingURL=VirginIslandsUS.js.map